export const LOADING = 'triggerLoading';
export const ERROR = 'triggerError';
export const GETDEBUG = 'triggerGetDebug';
export const CLEARDEBUG = 'triggerClearDebug';
